import { useState, useEffect } from 'react';

const VERSION_KEY = '@EVAPI:app_version';
const VERSION_FILE_URL = '/version.json';

export const useAppVersion = () => {
    const [hasUpdate, setHasUpdate] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [currentVersion, setCurrentVersion] = useState('');
    const [versionInfo, setVersionInfo] = useState(null);

    useEffect(() => {
        checkForUpdate();
    }, []);

    const checkForUpdate = async () => {
        try {
            // Busca a versão do servidor (arquivo estático no build)
            const response = await fetch(`https://crm.sempereventos.com.br${VERSION_FILE_URL}?t=${Date.now()}`);
            if (!response.ok) {
                console.warn('Não foi possível verificar a versão do servidor');
                return;
            }

            const serverVersionInfo = await response.json();
            const serverVersion = serverVersionInfo.version;
            
            setCurrentVersion(serverVersion);
            setVersionInfo(serverVersionInfo);

            const storedVersion = localStorage.getItem(VERSION_KEY);
            
            if (!storedVersion) {
                // Primeira vez que o usuário acessa
                localStorage.setItem(VERSION_KEY, serverVersion);
                return;
            }

            // Verifica se há uma nova versão
            if (storedVersion !== serverVersion) {
                setHasUpdate(true);
                setShowUpdateModal(true);
            }
        } catch (error) {
            console.error('Erro ao verificar versão:', error);
        }
    };

    const updateApp = async () => {
        try {
            // Limpa todos os caches
            await clearAllCaches();
            
            // Atualiza a versão no localStorage
            localStorage.setItem(VERSION_KEY, currentVersion);
            
            // Recarrega a página para aplicar as mudanças
            window.location.reload(true);
        } catch (error) {
            console.error('Erro ao atualizar o app:', error);
            // Mesmo com erro, tenta recarregar
            localStorage.setItem(VERSION_KEY, currentVersion);
            window.location.reload(true);
        }
    };

    const clearAllCaches = async () => {
        try {
            // Limpa Cache API (Service Workers)
            if ('caches' in window) {
                const cacheNames = await caches.keys();
                await Promise.all(
                    cacheNames.map(cacheName => caches.delete(cacheName))
                );
            }

            // Limpa sessionStorage (mantém apenas o essencial)
            const token = sessionStorage.getItem('@EVAPI:token');
            const user = sessionStorage.getItem('@EVAPI:user');
            const permissions = sessionStorage.getItem('@EVAPI:permissions');
            
            sessionStorage.clear();
            
            // Restaura dados de autenticação
            if (token) sessionStorage.setItem('@EVAPI:token', token);
            if (user) sessionStorage.setItem('@EVAPI:user', user);
            if (permissions) sessionStorage.setItem('@EVAPI:permissions', permissions);

        } catch (error) {
            console.error('Erro ao limpar caches:', error);
        }
    };

    const dismissUpdate = () => {
        setShowUpdateModal(false);
        // Atualiza a versão mesmo sem atualizar, para não mostrar novamente
        localStorage.setItem(VERSION_KEY, currentVersion);
    };

    return {
        hasUpdate,
        showUpdateModal,
        updateApp,
        dismissUpdate,
        currentVersion,
        versionInfo
    };
};
